import { GdeltStreamInspector } from "@/components/developer/gdelt-stream-inspector";
import { SiteNav } from "@/components/layout/site-nav";
import { siteConfigRepository } from "@/repositories/site-config-repository";

export default function DeveloperGdeltPage() {
  const config = siteConfigRepository.getSiteConfig();
  return <><SiteNav brand={config.brand} items={config.navigation} developerItems={config.developerNavigation} /><GdeltStreamInspector /></>;
}
